import { Main } from "wikr-core-analytics";

export function getAnalyticData() {
  const isInitAmazonAnalytic = Main.checkIsAlreadyInited({ name: 'amazon' });

  return (isInitAmazonAnalytic &&  Main?.getDefaultAmazonAnalyticPurchaseData?.()) || {};
}
